export default __webpack_public_path__ + "static/media/prj.ce08b58e.png";